// Inline SVG icons for the bottom nav. Stroke-style, 22×22, `currentColor`
// so they pick up the button's color. Visuals taken from the Claude Design
// "D" handoff (icons.jsx) so the modern theme matches that prototype.

import type { CSSProperties } from "react";

const base: CSSProperties = {
  width: 22,
  height: 22,
  display: "block",
};

export function IconBell({ style }: { style?: CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" style={{ ...base, ...style }}>
      <path
        d="M18 8.4A6 6 0 0 0 6 8.4c0 5.2-2.2 6.6-2.2 6.6h16.4S18 13.6 18 8.4Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7 19a2 2 0 0 1-3.4 0"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconUsers({ style }: { style?: CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" style={{ ...base, ...style }}>
      <path
        d="M15.5 19v-1.6a3.4 3.4 0 0 0-3.4-3.4H6.4A3.4 3.4 0 0 0 3 17.4V19"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="9.2" cy="7.2" r="3.2" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M21 19v-1.6a3.4 3.4 0 0 0-2.6-3.3M16 4.1a3.4 3.4 0 0 1 0 6.2"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** "Master" — stylist silhouette with a small sparkle. */
export function IconSparkle({ style }: { style?: CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" style={{ ...base, ...style }}>
      <circle cx="9.6" cy="8.3" r="3.3" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M3.9 20a5.7 5.7 0 0 1 11.4 0"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M18 3.4c.36 1.65.66 1.95 2.3 2.3-1.64.36-1.94.66-2.3 2.3-.36-1.64-.66-1.94-2.3-2.3C17.34 5.34 17.64 5.04 18 3.4Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconChart({ style }: { style?: CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" style={{ ...base, ...style }}>
      <path
        d="M4 20V4M20 20H4"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="7.5"
        y="11"
        width="3"
        height="6"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <rect
        x="13.5"
        y="7"
        width="3"
        height="10"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.8"
      />
    </svg>
  );
}

/** Small inline sparkle — used in the logo and the ✨ theme pill. */
export function IconSparkleSolid({ style }: { style?: CSSProperties }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      style={{ width: 15, height: 15, display: "block", ...style }}
    >
      <path d="M12 3.5 13.6 9 19 10.6 13.6 12.2 12 17.6 10.4 12.2 5 10.6 10.4 9 12 3.5Z" />
    </svg>
  );
}
